export * from './IEntityDescription'
